//
// Copyright 2023 DXOS.org
//

import { type Resource } from '@dxos/react-ui';

export const translations = [
  {
    'en-US': {
      testbench: {},
    },
  },
] as const satisfies Resource[];
